import { Action } from 'redux'
import { IEvent } from '../../../models/Event'
import { EventActions } from '../../../reducers/bookingCalendar/actionNames'

const requestDataForEvents = (): IRequestDataForEvents => ({
  type: EventActions.RequestDataForEvents,
})

export default requestDataForEvents
export type IRequestDataForEvents = Action<EventActions.RequestDataForEvents>

export const dataForEventsIsAccepted = (
  data: IEvent[],
  putToDB = true,
  fullRange?: boolean,
  from?: Date,
  to?: Date,
): IDataForEventsIsAccepted => ({
  events: data,
  from,
  fullRange,
  putToDB,
  to,
  type: EventActions.DataForEventsAccepted,
})

export interface IDataForEventsIsAccepted
  extends Action<EventActions.DataForEventsAccepted> {
  events: IEvent[]
  putToDB: boolean
  fullRange?: boolean
  from?: Date
  to?: Date
}

export const dataForEventsIsRejected = (
  errMessage: string,
): IDataForEventsIsRejected => ({
  errMessage,
  type: EventActions.DataForEventsRejected,
})

export interface IDataForEventsIsRejected
  extends Action<EventActions.DataForEventsRejected> {
  errMessage: string
}

export const databaseForEventsIsEmpty = (
  lastModifyDate?: Date,
  onlyToBase = false,
  putToDB = false,
): IDatabaseForEventsEmpty => ({
  lastModifyDate,
  onlyToBase,
  putToDB,
  type: EventActions.DatabaseForEventsIsEmpty,
})

export interface IDatabaseForEventsEmpty
  extends Action<EventActions.DatabaseForEventsIsEmpty> {
  lastModifyDate?: Date
  onlyToBase?: boolean
  putToDB?: boolean
}
